import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';

const Layout: React.FC = () => {
  // @ts-ignore
  const { t, i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // 直接从public文件夹引用图片
  const publicLogoUrl = `/matrix_logo_T.png?t=${Date.now()}`;

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setDropdownOpen(false);
  };

  return (
    <div className="App">
      <header className="App-header">
        <nav className="navbar">
          <Link to="/" className="logo">
            <img 
              src={publicLogoUrl} 
              alt="Matrix Logo" 
              className="site-logo" 
            />
          </Link>
          <div className="nav-links">
            {/* @ts-ignore */}
            <Link to="/">{t('nav.home')}</Link>
            {/* @ts-ignore */}
            <Link to="/about">{t('nav.about')}</Link>
            {/* @ts-ignore */}
            <Link to="/services">{t('nav.services')}</Link>
            {/* @ts-ignore */}
            <Link to="/contact">{t('nav.contact')}</Link>
            
            <div className="language-dropdown">
              <button 
                className="globe-icon" 
                onClick={() => setDropdownOpen(!dropdownOpen)}
                aria-label="Select language"
              >
                🌐
              </button>
              {dropdownOpen && (
                <div className="dropdown-content">
                  <button onClick={() => changeLanguage('en')}>English</button>
                  <button onClick={() => changeLanguage('zh-CN')}>简体中文</button>
                  <button onClick={() => changeLanguage('zh-TW')}>繁體中文</button>
                  <button onClick={() => changeLanguage('ja')}>日本語</button>
                </div>
              )}
            </div>
          </div>
        </nav>

        <main className="main-content">
          <Outlet />
        </main>
        
        <footer className="footer">
          <div className="footer-content">
            {/* @ts-ignore */}
            <p>{t('common.copyright')}</p>
            <div className="social-icons">
              <a href="#" aria-label="Facebook">📱</a>
              <a href="#" aria-label="Twitter">💬</a>
              <a href="#" aria-label="LinkedIn">🔗</a>
            </div>
          </div>
        </footer>
      </header>
    </div>
  );
};

export default Layout; 